export default "__VITE_PUBLIC_ASSET__1be3a582__"